// views/SpaView.tsx
import React from 'react';
import { Navigation } from '../../components/navigation/navigation';
import { Landing } from '../../components/landing/landing';
import { Studio } from '../../components/studio/studio';
import { Services } from '../../components/services/services';
import { Contact } from '../../components/contact/contact';
import { Footer } from '../../components/footer/footer';
import './spa.css';

interface SpaViewProps {
  lang: string;
}

export const SpaView: React.FC<SpaViewProps> = ({ lang }) => {
  return (
    <div className="spa-view">
      <Navigation lang={lang} />
      <Landing lang={lang} />
      <Studio lang={lang} />
      <Services lang={lang} />
      <Contact lang={lang} />
      <Footer lang={lang} />
    </div>
  );
};
